import { IonCol, IonFooter, IonRow } from '@ionic/react'; //IonImg
import { NavLink, useHistory } from 'react-router-dom';

import taro from '../../../resources/taro-red.png';
import styles from './TaroFooter.module.scss';

const TaroFooter = () => {
   const history = useHistory();

   return (
      <IonFooter
         className={`ion-no-border ${styles.mainFooter}`}
         id='main-footer'
         resource-id='main-footer'
         data-cy='main-footer'
      >
         <div className={styles.footer}>
            <IonRow
               className={styles.footerWrapper}
               id='footer-link-wrapper'
               resource-id='footer-link-wrapper'
               data-cy='footer-link-wrapper'
            >
               <IonCol
                  size='3'
                  className={styles.footerCol}
               >
                  <NavLink
                     id='home-route'
                     exact
                     to='/'
                     onClick={(e) => {
                        e.preventDefault();
                        history.replace('/');
                     }}
                     className={`${styles.navItem} centered`}
                     resource-id='home-navlink'
                     data-cy='home-navlink'
                     activeClassName={styles.activeNav}
                  >
                     <img
                        className={`${styles.footerImg} ${styles.homeLink}`}
                        alt='home link'
                     />
                  </NavLink>
               </IonCol>
               <IonCol
                  size='3'
                  className={styles.footerCol}
               >
                  <NavLink
                     id='support-route'
                     to='/support'
                     onClick={(e) => {
                        e.preventDefault();
                        history.replace('/support');
                     }}
                     className={`${styles.navItem} centered`}
                     resource-id='support-navlink'
                     data-cy='support-navlink'
                     activeClassName={styles.activeNav}
                  >
                     <img
                        className={`${styles.footerImg} ${styles.supportLink}`}
                        alt='support link'
                     />
                     {/* <IonIcon
                        slot='icon-only'
                        icon={chat}
                     /> */}
                  </NavLink>
               </IonCol>
               <IonCol
                  size='3'
                  className={styles.footerCol}
               >
                  <NavLink
                     id='profile-route'
                     to='/profile'
                     onClick={(e) => {
                        e.preventDefault();
                        history.replace('/profile');
                     }}
                     className={`${styles.navItem} centered`}
                     resource-id='profile-navlink'
                     data-cy='profile-navlink'
                     activeClassName={styles.activeNav}
                  >
                     <img
                        className={`${styles.footerImg} ${styles.profileLink}`}
                        alt='profile link'
                     />
                  </NavLink>
               </IonCol>
               <IonCol
                  size='3'
                  className={styles.footerCol}
               >
                  <img
                     className={styles.footerImg}
                     src={taro}
                     alt='taro'
                     id='taro-img'
                     resource-id='taro-img'
                     data-cy='taro-img'
                  />
               </IonCol>
            </IonRow>
         </div>
      </IonFooter>
   );
};

export default TaroFooter;
